import { c as _c } from "react/compiler-runtime";
import React from "react";
export const WaveWinnersTimelineLoading: React.FC = () => {
  const $ = _c(3);
  const renderLoadingItem = _temp;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-absolute tw-left-2.5 sm:tw-left-[19px] tw-top-0 tw-bottom-0 tw-w-px tw-bg-iron-700/80 tw-backdrop-blur-sm" />;
    t1 = <div className="tw-absolute tw-left-2.5 sm:tw-left-[18px] tw-top-0 tw-bottom-0 tw-w-[3px] tw-bg-gradient-to-b tw-from-iron-900 tw-via-iron-700/20 tw-to-iron-900 tw-opacity-40 tw-blur-sm" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-pt-2 lg:tw-pt-4 tw-pb-4 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300"><div className="tw-relative">{t0}{t1}<div className="tw-space-y-8">{[1, 2, 3].map(index_0 => renderLoadingItem(index_0))}</div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(index) {
  return <div key={index} className="tw-relative"><div className="tw-absolute tw-left-0.5 lg:tw-left-[19px] tw-top-0"><div className="tw-size-4 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-animate-pulse"><div className="tw-rounded-full tw-bg-iron-600 tw-size-2.5" /></div></div><div className="tw-ml-6 lg:tw-ml-10 tw-mb-2 lg:tw-mb-3"><div className="tw-flex tw-flex-wrap tw-items-baseline tw-gap-x-3 tw-gap-y-1"><div className="tw-h-5 tw-w-28 tw-bg-iron-800 tw-rounded-md tw-animate-pulse" /><div className="tw-h-6 tw-w-20 tw-bg-iron-800 tw-rounded-md tw-animate-pulse" /><div className="tw-h-4 tw-w-16 tw-bg-iron-800 tw-rounded-md tw-animate-pulse" /></div></div><div className="tw-ml-6 lg:tw-ml-10"><div className="tw-rounded-lg tw-border-l-2 tw-border-iron-600/40 tw-border-y-0 tw-border-r-0"><div className="lg:tw-px-4 tw-pb-4"><div className="tw-h-40 tw-bg-iron-800 tw-rounded-lg tw-animate-pulse" /></div></div></div></div>;
}